import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_46c570c5: FaireBrandEntity = {
  token: "b_46c570c5",
  type: "brand",
  name: "Solmate Socks",
  avatarUrl:
    "https://cdn.faire.com/fastly/b6bf16d47ea209b1f7f36f342c575fec9cffdfff83935726729c66d0ae83f7d1.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/db04da8823fa05910b2e22e4c2f0579180eef36fbc1ce6a6d1d008115a912f7f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b6bf16d47ea209b1f7f36f342c575fec9cffdfff83935726729c66d0ae83f7d1.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/db04da8823fa05910b2e22e4c2f0579180eef36fbc1ce6a6d1d008115a912f7f.jpeg",
  location: "Portland, OR, USA",
  minimumOrderDollars: 148,
  rating: 5,
  reviewCount: 109,
  isTopShop: true,
  isInsider: true,
  description:
    "We make awesome socks. They are full of love, warmth and character. But we are so much more than that! As a Certified B-Corporation, we are proud to be part of a global movement of diverse businesses working together for a positive change. Because together, we can prepare today for a better tomorrow. Each product is locally-crafted at our own mill in Hickory, North Carolina and hand-finished to last a lifetime. Sustainably sourced. Made in USA. Crafted with love to embrace inclusivity for all.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:13.230Z",
    importedBy: "entity-db-cli",
  },
};
